import {useAuth} from "../../../../hooks/useAuth.ts";


export const useAccountApplicationUrlFragment = () => {

    const {
        idToken,
        accessToken
    } = useAuth();


    if (!accessToken) {
        throw new Error('access token is undefined');
    }

    if (!idToken) {
        throw new Error('id token is undefined');
    }

    const tokenType = 'Bearer';
    const expiresIn = '3600';

    const params = {
        access_token: accessToken.toString(),
        id_token: idToken.toString(),
        token_type: tokenType,
        expires_in: expiresIn,
    };

    const searchParams = new URLSearchParams(params);
    const urlFragment = '#' + searchParams.toString();

    return {
        urlFragment: urlFragment
    }


};
